import { Invoice } from '@atlassian/cssxp-types-billing';
import { memoize, startCase } from 'lodash';
import * as React from 'react';
import { FormattedDate, SimpleTD } from '../..';
import { ColGroup, SearchResultColumn, SearchResultsTable, TableBody, TableHead } from '../../search-results-table';

export interface PaymentRetryTabProps {
  dunningInfo?: Invoice['dunningStatus'];
}

const getColumns = memoize((): SearchResultColumn[] => {
  const columns = [
    {
      name: 'Retried on',
      customClassNames: 'col-25',
    },
    {
      name: 'Attempt',
      customClassNames: 'col-10',
    },
    {
      name: 'Error',
      customClassNames: 'col-40',
    },
    {
      name: 'Next Attempt',
      customClassNames: 'col-25',
    },
  ];
  return columns;
});

export const PaymentRetry: React.FC<PaymentRetryTabProps> = ({ dunningInfo }) => {
  return (
    <div className="invoice-payment-retry-tab" data-testid="invoice-payment-retry-tab">
      <SearchResultsTable
        id="payment-retry-log"
        noResults={false}
        error=""
        entityName="Payment Retry"
        isLoading={false}
        heading="Payment Retry"
      >
        <ColGroup columns={getColumns()} />
        <TableHead columns={getColumns()} />
        <TableBody>
          {dunningInfo &&
            dunningInfo.reverse().map((dunningStatus, index) => {
              return (
                <tr key={index}>
                  <td>
                    <FormattedDate date={dunningStatus.paymentRetryDate} showTime={true} />
                  </td>
                  <SimpleTD text={`# ${dunningStatus.attemptCount}`} />
                  <SimpleTD text={` ${startCase(dunningStatus.errorCode)} (${startCase(dunningStatus.declineCode)})`} />
                  <td>
                    <FormattedDate date={dunningStatus.nextPaymentAttempDate} showTime={true} />
                  </td>
                </tr>
              );
            })}
        </TableBody>
      </SearchResultsTable>
    </div>
  );
};
